// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-H3":"H3_vanlife-roadtrips-H3__8N_t5"};